import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { StatusQuoSection } from './components/StatusQuoSection';
import { FrameworkSection } from './components/FrameworkSection';
import { ServicesSection } from './components/ServicesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { ContactSection } from './components/ContactSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen bg-[#0A0A0A] text-white font-sans selection:bg-blue-500/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <RecentPurchaseToast data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <StatusQuoSection data-id="element-5" />
        <FrameworkSection data-id="element-6" />
        <ServicesSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <ContactSection data-id="element-10" />
        <ClosingSection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}